// resumeProgressUtils.js - 이력서 진행 상황 관련 유틸리티

import { sectionTitles } from '../components/resume/common/resumeConstants';

// 진행 상황 항목 추출
export const getProgressItems = (resumeData, language = 'kr') => {
  const titles = sectionTitles[language] || sectionTitles.kr;
  
  const items = [
    { key: 'name', name: '이름', completed: !!resumeData.name },
    { key: 'email', name: '이메일', completed: !!resumeData.email },
    { key: 'phone', name: '연락처', completed: !!resumeData.phone },
    { key: 'summary', name: titles.introduction, completed: !!resumeData.summary },
    { key: 'keyStrengths', name: titles.coreCompetencies.replace(':', ''), completed: resumeData.keyStrengths?.length > 0 },
    { key: 'experiences', name: titles.experience, completed: resumeData.experiences?.length > 0 },
    { key: 'education', name: titles.education, completed: resumeData.education?.length > 0 },
    { key: 'skills', name: titles.skills, completed: resumeData.skills?.length > 0 },
    { key: 'certificates', name: titles.certificates, completed: resumeData.certificates?.length > 0 },
  ];
  
  // 논문이 있는 경우에만 추가
  if (resumeData.papers?.length > 0) {
    items.splice(7, 0, { 
      key: 'papers', 
      name: titles.papers, 
      completed: true 
    });
  }
  
  return items;
};

// 전체 진행률 계산
export const calculateProgress = (resumeData, language = 'kr') => {
  const items = getProgressItems(resumeData, language);
  const completedItems = items.filter(item => item.completed).length;
  return Math.round((completedItems / items.length) * 100);
};
